/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../core/components';
import { Component } from '@angular/core';
import { MetricsEnum } from '../../shared';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss']
})

export class OverviewComponent extends BaseComponent {
    /**
     * To store the metrics enum.
     */
    public MetricsEnum = MetricsEnum;

    constructor() {
        super();
    }
}
